import PropTypes from 'prop-types';
import React from 'react';

const AdminPageHead = ({ title, subtitle, children }) => (
  <div className="adash-pagehead">
    <div>
      <h1>{title}</h1>
      {subtitle ? <p>{subtitle}</p> : null}
    </div>
    {children ? <div className="adash-pagehead-actions">{children}</div> : null}
  </div>
);

AdminPageHead.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.node,
  children: PropTypes.node,
};

export default AdminPageHead;
